// Piezas que comparten las pantallas de Seguridad (usuarios y roles). Son las mismas de clientes
// y de RRHH: carga local con esqueleto y "Reintentar", escrituras con aviso, envío sin duplicar y
// confirmaciones con ConfirmDialog.
export {
  ERROR_OTRA_SESION,
  encabezadoTabla,
  llevarAlPrimerError,
  normalizar,
  ocultoVisual,
  useCargaLocal,
  useConfirmacion,
  useEnvio,
  useEscritura,
  CargandoFormularioEmpleado as CargandoFormulario,
} from "../rrhh/employees/comunes";

// "GERENCIA GENERAL" es el rol más alto: no tiene jefe inmediato. En ese caso el servidor recibe el
// id del rol como supervisor, como siempre lo mandó la web.
export const ROL_SIN_JEFE = 2;

export const PAGINACION_ARIA = (tipo) =>
  ({
    first: "Primera página",
    last: "Última página",
    next: "Página siguiente",
    previous: "Página anterior",
  }[tipo]);
